import axios from "axios";
import { apiErrorHandler } from "./helper/handler";

const prefix = "marketing-news-banner";

const GET_ALL_MARKETING_NEWS_BANNER_URL = `${prefix}/all`;
const GET_MARKETING_NEWS_BANNER_URL = `${prefix}/get`;
const CREATE_MARKETING_NEWS_BANNER_URL = `${prefix}/create`;
const UPDATE_MARKETING_NEWS_BANNER_BY_ID_URL = `${prefix}/update-by-id`;
const DELETE_MARKETING_NEWS_BANNER_BY_ID_URL = `${prefix}/delete-by-id`;

/**
 * @func getAllMarketingNewsBanner
 * @desc get all news banner data
 * @author izeberg
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Array} news banner array
 */
export const getAllMarketingNewsBanner = async (queryParams, signal) => {
    try {
        const { data, status } = await axios.get(GET_ALL_MARKETING_NEWS_BANNER_URL, {
            params: queryParams,
            signal,
        });
        if (status === 200) {
            return data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "getAllMarketingNewsBanner");
        if (err) throw err;
        return undefined;
    }
};
/** End @func getAllMarketingNewsBanner */

/**
 * @func getMarketingNewsBanner
 * @desc get news banner data
 * @author izeberg
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Array} news banner array
 */
export const getMarketingNewsBanner = async (signal) => {
    try {
        const { data, status } = await axios.get(GET_MARKETING_NEWS_BANNER_URL, {
            signal,
        });
        if (status === 200) {
            return data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "getMarketingNewsBanner");
        if (err) throw err;
        return undefined;
    }
};
/** End @func getMarketingNewsBanner */

/**
 * @func createMarketingNewsBanner
 * @desc create new news banner
 * @author izeberg
 * @param {Object} body - create news banner body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {boolean} create status
 */
export const createMarketingNewsBanner = async (body, signal) => {
    try {
        const { status } = await axios.post(CREATE_MARKETING_NEWS_BANNER_URL, body, {
            signal,
        });
        if (status === 201) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "createMarketingNewsBanner");
        if (err) throw err;
        return undefined;
    }
};
/** End @func createMarketingNewsBanner */

/**
 * @func updateMarketingNewsBannerById
 * @desc update news banner by id
 * @author izeberg
 * @param {number} id - news banner id
 * @param {Object} body - update news banner body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {boolean} update status
 */
export const updateMarketingNewsBannerById = async (id, body, signal) => {
    try {
        const { status } = await axios.put(`${UPDATE_MARKETING_NEWS_BANNER_BY_ID_URL}/${id}`, body, {
            signal,
        });
        if (status === 200) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "updateMarketingNewsBannerById");
        if (err) throw err;
        return undefined;
    }
};
/** End @func updateMarketingNewsBannerById */

/**
 * @func deleteMarketingNewsBannerById
 * @desc delete news banner by id
 * @author izeberg
 * @param {Object} body - create news banner body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Array} news banner array
 */
export const deleteMarketingNewsBannerById = async (id, signal) => {
    try {
        const { status } = await axios.delete(`${DELETE_MARKETING_NEWS_BANNER_BY_ID_URL}/${id}`, {
            signal,
        });
        if (status === 200) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "deleteMarketingNewsBannerById");
        if (err) throw err;
        return undefined;
    }
};
/** End @func deleteMarketingNewsBannerById */
